import React from 'react';
import { Header } from 'semantic-ui-react';
import CreateNewPollForm from './CreatePoll/CreateNewPollFormw';


export default class PollEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }


    render() {
        return (

            <div>

                {/* preview */}
                <Header as="h1">Uređivanje ankete </Header>

                {
                    localStorage.getItem('edit') &&
                        <CreateNewPollForm />
                }

                {/*{ localStorage.getItem('question') && <PollPreview />}*/}


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollEdit.js